// 選手が負担する決済手数料（オーナー決定 2026-09-28、2026-10-01）。
// カード会社の加盟店規約でカード利用者だけへの上乗せは禁じられているため、カードを受け付ける大会では支払い方法によらず全員一律とする。
// カード決済（3.6%）でも主催者の手取りが参加費に届くよう、参加費 ÷ (1 − 0.036) を1円未満切り上げた額との差にする。
// カードのみの大会は3.6%のまま。銀行振込のみの大会は、Stripe の銀行振込の料率（1.5%）で同じ計算をする
export const CARD_RATE_PERMILLE = 36;
export const BANK_RATE_PERMILLE = 15;
export function participantFee(fee: number, methods: "card_bank" | "bank" | "card" = "card_bank"): number {
  if (!(fee > 0)) return 0;
  const rate = methods === "bank" ? BANK_RATE_PERMILLE : CARD_RATE_PERMILLE;
  return Math.ceil((fee * 1000) / (1000 - rate)) - fee;
}

// 観覧チケットの1回の購入の金額（functions/src/domain/ticket.ts の orderAmounts と同じ計算。オーナー決定 2026-10-10）。
// 決済手数料は1枚ずつではなく、合計（価格 × 枚数）から求める。画面の表示はこの関数だけを使う
// roundUnit（10・50・100）があるときは、1枚あたりの支払額をその単位で切り上げる（サーバーの orderAmounts と同じ式。オーナー決定 2026-10-10）
export function orderTotal(unitFee: number, quantity: number, feeIncluded: boolean, methods: "card_bank" | "bank" | "card" = "card_bank", roundUnit?: number): { entryFee: number; surcharge: number; total: number } {
  const entryFee = unitFee * quantity;
  const surcharge = feeIncluded ? 0
    : roundUnit ? (Math.ceil((unitFee + participantFee(unitFee, methods)) / roundUnit) * roundUnit - unitFee) * quantity
    : participantFee(entryFee, methods);
  return { entryFee, surcharge, total: entryFee + surcharge };
}
